import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
export var appendDeletedProductDetail = function() {
    var deletedRows = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], productDetail = arguments.length > 1 ? arguments[1] : void 0;
    var detailId = Number((productDetail === null || productDetail === void 0 ? void 0 : productDetail.pd_pdetail_id) || 0);
    if ((productDetail === null || productDetail === void 0 ? void 0 : productDetail.type) !== "update" || detailId <= 0) return deletedRows;
    if (deletedRows.some(function(row) {
        return Number(row.pd_pdetail_id || 0) === detailId;
    })) {
        return deletedRows;
    }
    return _to_consumable_array(deletedRows).concat([
        {
            pd_pdetail_id: detailId
        }
    ]);
};
